























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import OrderDarahSvc from "@/services/OrderDarah";
import { storeOrderDarah } from "@/store/modules/OrderDarahStore";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import OrderDarahFormDialog from "./OrderDarahFormDialog.vue";
import CetakLabelKantongDialog from "./CetakLabelKantongDialog.vue";
import { ORDER_DARAH } from "./orderDarah.config";
import type { OrderDarahJenis } from "@/types/order_darah";
import { STATUS_WARNA } from "@/types/order_bank_darah";
import { alasanTidakBisaHapusPermintaan } from "@/utils/hapusPermintaanDarah";
import { slotTandaTanganDokumen } from "@/utils/hapusSetelahTtd";

@Component({
  components: { CardModalTtd, OrderDarahFormDialog, CetakLabelKantongDialog },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class OrderDarahList extends Vue {
  @Prop({ type: String, required: true }) readonly jenis!: OrderDarahJenis;

  @Prop() readonly register!: string;

  @Prop() readonly rm!: string;

  isReadOnly!: () => boolean;

  formDialog = false;

  editData: any = null;

  modalTtd = false;

  signItem: any = null;

  dialogHapus = false;

  hapusItem: any = null;

  deleting = false;

  dialogLabel = false;

  labelItem: any = null;

  get cfg() {
    return ORDER_DARAH[this.jenis];
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get items() {
    return storeOrderDarah.itemsByJenis[this.jenis] || [];
  }

  get loading(): boolean {
    return !!storeOrderDarah.loadingByJenis[this.jenis];
  }

  get tableHeaders() {
    return [
      { text: "Tanggal", value: "tanggal_permintaan", width: "110px" },
      { text: "Nomor", value: "nomor", width: "170px" },
      { text: this.cfg.ringkasanHeader, value: "ringkasan_detail", sortable: false },
      ...(this.pakaiJenisOrder
        ? [{ text: "Jenis Order", value: "jenis_order", width: "100px", sortable: false }]
        : []),
      { text: "Status", value: "status", width: "130px", sortable: false },
      { text: "Aksi", value: "aksi", sortable: false, align: "end", width: "150px" }
    ];
  }

  get canMake(): boolean {
    const profesi = String(
      (userModule.user && userModule.user.profesi) || ""
    ).toLowerCase();
    return ["dokter", "perawat", "bidan"].indexOf(profesi) >= 0;
  }

  bisaTtd(item: any): boolean {
    if (item.is_locked || this.readOnly) return false;
    return (
      !!item.dokter_peminta_user_id &&
      !!userModule.user &&
      String(item.dokter_peminta_user_id) === String(userModule.user.id)
    );
  }

  alasanTidakBisaHapus(item: any): string {
    return alasanTidakBisaHapusPermintaan(
      item.status,
      item.creator_user_id,
      slotTandaTanganDokumen(item.signed_pengirim, item.signature_pengirim),
      userModule.user ? userModule.user.id : null
    );
  }

  onSaved(payload: { data: any; tandatangani: boolean } | undefined) {
    this.muatUlang();
    if (payload && payload.tandatangani && payload.data && payload.data.id) {
      this.bukaTtd(payload.data);
    }
  }

  mounted() {
    storeOrderDarah.loadKatalog();
    if (!storeDokter.list.length) {
      (storeDokter as any).act_dokter_all();
    }
    this.muatUlang();
  }

  @Watch("register")
  onRegisterChange() {
    this.formDialog = false;
    this.editData = null;
    this.modalTtd = false;
    this.signItem = null;
    this.muatUlang();
  }

  muatUlang() {
    if (!this.register) return;
    storeOrderDarah.getByRegister({ register: this.register, jenis: this.jenis });
  }

  warnaStatus(status: string): string {
    return STATUS_WARNA[status] || "blue-grey";
  }

  tanggal(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD").format("DD-MM-YYYY") : "-";
  }

  bukaForm(item: any) {
    this.editData = item;
    this.formDialog = true;
  }

  cetak(item: any) {
    OrderDarahSvc.printPdf(item.id);
  }

  get pakaiLabel(): boolean {
    return this.jenis === "komponen_rujukan";
  }

  get pakaiJenisOrder(): boolean {
    return this.jenis === "komponen_rujukan";
  }

  bukaLabel(item: any) {
    this.labelItem = item;
    this.dialogLabel = true;
  }

  cetakLabel(jumlah: number) {
    if (this.labelItem) OrderDarahSvc.printLabel(this.labelItem.id, jumlah);
  }

  bukaTtd(item: any) {
    this.signItem = item;
    appModule.addMsgTtd("");
    this.modalTtd = true;
  }

  async passTtd(password: string) {
    if (!this.signItem) return;

    try {
      const resp = await OrderDarahSvc.signPengirim(this.signItem.id, { password });
      if (resp.data.status == "1") {
        this.modalTtd = false;
        this.signItem = null;
        appModule.addMsgTtd("");
        appModule.NoticeDelay(resp.data.message || "Berhasil menandatangani");
        this.muatUlang();
      }
    } catch {
      this.modalTtd = true;
    }
  }

  konfirmHapus(item: any) {
    this.hapusItem = item;
    this.dialogHapus = true;
  }

  async hapus() {
    if (!this.hapusItem || this.deleting) return;

    this.deleting = true;
    try {
      const resp = await OrderDarahSvc.destroy(this.hapusItem.id);
      if (resp.data.status == "1") {
        appModule.sendSuccessNotice(resp.data.message || "Berhasil dihapus");
        this.dialogHapus = false;
        this.hapusItem = null;
        this.muatUlang();
      }
    } catch {
      return;
    } finally {
      this.deleting = false;
    }
  }
}
